import React, { FC } from 'react';

import { IDangerouslySetInnerHtml } from './models';

const DangerouslySetInnerHtml: FC<IDangerouslySetInnerHtml> = ({ html, element, ...rest }) => {
  const Tag = element || 'div';

  return html ? <Tag dangerouslySetInnerHTML={{ __html: html }} {...rest} /> : null;
};

export default DangerouslySetInnerHtml;
